import RegisterFormController from "../components/register/RegisterFormController";
import RequestFormController from "../components/register/RequestFormController";
import SignInFormController from "../components/signIn/signInFormController";
import CheckboxToggleController from '../components/checkboxToggle/CheckboxToggleController';

const registerFormContainer = document.querySelector('.js-element--registerFormContainer');
const requestFormContainer = document.querySelector('.js-element--requestFormContainer');
const signInFormContainer = document.querySelector('.js-element--signInContainer');
const defaultMessageContainer = document.querySelector('.js-element--defaultMessage');
const checkboxToggleContainer = document.querySelector('.js-element--checkboxToggleContainer');
const backToSignInElement = document.querySelector('.js-element--backToSignIn');

new RegisterFormController(registerFormContainer);
new RequestFormController(requestFormContainer);
new SignInFormController(signInFormContainer, onSucessCallBack);
new CheckboxToggleController(checkboxToggleContainer, registerFormContainer, requestFormContainer, defaultMessageContainer, backToSignInElement);

function onSucessCallBack () {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirect');
    
    redirectUrl ? window.location.assign(decodeURIComponent(redirectUrl)) : window.location.assign('/');
}